const ethereumRequestArrayOfResults_ = async (method: string) =>
	window.ethereum.request
		? window.ethereum.request({
				method,
		  })
		: [];

export const isEthereum = (): boolean /** is window.ethereum */ => typeof window.ethereum !== 'undefined';

export const isMetaMask = () => !!window.ethereum.isMetaMask;

export const getAccounts = async () => ethereumRequestArrayOfResults_('eth_accounts');

export const fetchAccounts = async () => ethereumRequestArrayOfResults_('eth_requestAccounts');
